import { render, staticRenderFns } from "./ColorPickerComponent.vue?vue&type=template&id=bea9956e&scoped=true&"
import script from "./ColorPickerComponent.vue?vue&type=script&lang=js&"
export * from "./ColorPickerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerComponent.vue?vue&type=style&index=0&id=bea9956e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea9956e",
  null
  
)

export default component.exports